/* eslint-disable object-curly-newline */
import keyboardIcon from '@/assets/images/icons/logs/category/keyboard.svg';
import screenshotsIcon from '@/assets/images/icons/logs/category/screenshots.svg';
import programsIcon from '@/assets/images/icons/logs/category/programs.svg';
import filesIcon from '@/assets/images/icons/logs/category/files.svg';
import clipboardIcon from '@/assets/images/icons/logs/category/clipboard.svg';
import printerIcon from '@/assets/images/icons/logs/category/printer.svg';
import installedProgramsIcon from '@/assets/images/icons/logs/category/installed-programs.svg';
import externalDrivesIcon from '@/assets/images/icons/logs/category/external-drives.svg';
import visitedSitesIcon from '@/assets/images/icons/logs/category/visited-sites.svg';
import computerIcon from '@/assets/images/icons/logs/category/computer.svg';
import shadowCopyingsIcon from '@/assets/images/icons/logs/category/shadow-copyings.svg';
import emailClientsIcon from '@/assets/images/icons/logs/category/email-clients.svg';
import networkAccessesIcon from '@/assets/images/icons/logs/category/network-accesses.svg';
import networkFilesIcon from '@/assets/images/icons/logs/category/network-files.svg';
import webMailIcon from '@/assets/images/icons/logs/category/web-mail.svg';
import fileUploadIcon from '@/assets/images/icons/logs/category/file-upload.svg';
import socialNetworksIcon from '@/assets/images/icons/logs/category/social-networks.svg';
import messengersIcon from '@/assets/images/icons/logs/category/messengers.svg';
import webcamsAndMicrophonesIcon from '@/assets/images/icons/logs/category/webcams-and-microphones.svg';
import hardwareChangesIcon from '@/assets/images/icons/logs/category/hardware-changes.svg';
import searchQueriesIcon from '@/assets/images/icons/logs/category/search-queries.svg';
import micRecordsIcon from '@/assets/images/icons/logs/category/mic-records.svg';

import i18n from '@/api/i18n/i18n';

export const logTypes = [
  {
    id: 1,
    slug: 'keyboard',
    name: i18n.t('accessLogs.keyboard'),
    category: 'events',
    color: '#FF0000',
    checked: false,
    img: keyboardIcon,
  },
  {
    id: 2,
    slug: 'screenshots',
    name: i18n.t('accessLogs.screenshots'),
    category: 'events',
    color: '#00FF00',
    checked: false,
    img: screenshotsIcon,
  },
  {
    id: 3,
    slug: 'programs',
    name: i18n.t('accessLogs.programs'),
    category: 'events',
    color: '#0000FF',
    checked: false,
    img: programsIcon,
  },
  {
    id: 4,
    slug: 'files',
    name: i18n.t('accessLogs.files'),
    category: 'events',
    color: '#DA70D6',
    checked: false,
    img: filesIcon,
  },
  {
    id: 5,
    slug: 'clipboard',
    name: i18n.t('accessLogs.clipboard'),
    category: 'events',
    color: '#FF00FF',
    checked: false,
    img: clipboardIcon,
  },
  {
    id: 6,
    slug: 'printer',
    name: i18n.t('accessLogs.printer'),
    category: 'devices',
    color: '#00FFFF',
    checked: false,
    img: printerIcon,
  },
  {
    id: 7,
    slug: 'installed-programs',
    name: i18n.t('accessLogs.installedPrograms'),
    category: 'events',
    color: '#800000',
    checked: false,
    img: installedProgramsIcon,
  },
  {
    id: 8,
    slug: 'external-drives',
    name: i18n.t('accessLogs.externalDrives'),
    category: 'devices',
    color: '#008000',
    checked: false,
    img: externalDrivesIcon,
  },
  {
    id: 10,
    slug: 'visited-sites',
    name: i18n.t('accessLogs.visitedSites'),
    category: 'internet',
    color: '#000080',
    checked: false,
    img: visitedSitesIcon,
  },
  {
    id: 11,
    slug: 'computer',
    name: i18n.t('accessLogs.computer'),
    category: 'events',
    color: '#808000',
    checked: false,
    img: computerIcon,
  },
  {
    id: 14,
    slug: 'shadow-copyings',
    name: i18n.t('accessLogs.shadowCopy'),
    category: 'devices',
    color: '#800080',
    checked: false,
    img: shadowCopyingsIcon,
  },
  {
    id: 15,
    slug: 'email-clients',
    name: i18n.t('accessLogs.mail'),
    category: 'internet',
    color: '#008080',
    checked: false,
    img: emailClientsIcon,
  },
  {
    id: 18,
    slug: 'network-accesses',
    name: i18n.t('accessLogs.networkAccess'),
    category: 'events',
    color: '#C0C0C0',
    checked: false,
    img: networkAccessesIcon,
  },
  {
    id: 19,
    slug: 'network-files',
    name: i18n.t('accessLogs.networkFiles'),
    category: 'events',
    color: '#808080',
    checked: false,
    img: networkFilesIcon,
  },
  {
    id: 20,
    slug: 'web-mail',
    name: i18n.t('accessLogs.webMail'),
    category: 'internet',
    color: '#FFA500',
    checked: false,
    webMailIcon,
  },
  {
    id: 21,
    slug: 'file-upload',
    name: i18n.t('accessLogs.fileUpload'),
    category: 'internet',
    color: '#FFC0CB',
    checked: false,
    img: fileUploadIcon,
  },
  {
    id: 22,
    slug: 'social-networks',
    name: i18n.t('accessLogs.socialNetworks'),
    category: 'internet',
    color: '#A52A2A',
    checked: false,
    img: socialNetworksIcon,
  },
  {
    id: 23,
    slug: 'messengers',
    name: i18n.t('accessLogs.messengers'),
    category: 'internet',
    color: '#DEB887',
    checked: false,
    img: messengersIcon,
  },
  {
    id: 24,
    slug: 'webcams-and-microphones',
    name: 'WebCam/Microphone',
    category: 'devices',
    color: '#5F9EA0',
    checked: false,
    img: webcamsAndMicrophonesIcon,
  },
  {
    id: 25,
    slug: 'hardware-changes',
    name: i18n.t('accessLogs.hardwareChanges'),
    category: 'devices',
    color: '#7FFF00',
    checked: false,
    img: hardwareChangesIcon,
  },
  {
    id: 26,
    slug: 'search-queries',
    name: i18n.t('accessLogs.searchQueries'),
    category: 'internet',
    color: '#D2691E',
    checked: false,
    img: searchQueriesIcon,
  },
  {
    id: 27,
    slug: 'mic-records',
    name: i18n.t('accessLogs.microphoneRecords'),
    category: 'devices',
    color: '#FF4500',
    checked: false,
    img: micRecordsIcon,
  },
];
